import React from 'react';
import SVGInline from "react-svg-inline";
import injectSheet from 'react-jss';

import CloseIcon from '../images/close.svg';

/**
 * 
 * Its basically a close button with a cross icon inside it
 * and customizable from outside
 */

export const GenericCloseButton = ({classes, className, ...rest}) => {
    return(    
        <button {...rest} className={` ${classes.container} ${className}`}>
            <SVGInline
                svg={CloseIcon}
                className={classes.icon}
            />
        </button>
    )
}


GenericCloseButton.defaultProps = {
    className: ''
}

const styles = {
    container: {
        cursor: 'pointer',
        display :'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '32px',
        height: '32px',
        border: 'none',
        borderRadius: '50%',
        backgroundColor: 'transparent',
        '&:hover':{
            backgroundColor: '#eceff5',
        }
    },

    icon: {
        width: '11px',
        height: '11px',
        transform: 'translateY(-3px)',
    }
}

export default (injectSheet(styles)(GenericCloseButton));
